import selectedProductReducer from './selectedProductReducer';

export default function productsReducer(state, action) {
    switch (action.type) {
        case 'updated':
        case 'imageAdded':
        case 'imageUpdated':
        case 'imageDeleted':
        case 'variantUpdated':
            return state.map((product) => {
                if (product.id === action.payload.product.id) {
                    return selectedProductReducer(product, action);
                }
                return product;
            });
        default:
            return state;
    }
}
